import axios from "axios";
import { BASE_URL } from "../_constants/urlConstants";
import { QSHEET } from "../_constants/actionConstants";
import { actionScripts } from "../_helpers/actionScripts";
import { getUUID } from "../_utils/generalUtils";

const fetchQSheet = (qSheetId, tabId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: QSHEET.FETCH, tabId });
    axios
      .get(`${BASE_URL}/api/QSheets/${qSheetId}`)
      .then((response) => {
        dispatch({
          type: QSHEET.FETCH_FULFILLED,
          tabId,
          payload: response.data,
        });
        resolve(response.data);
      })
      .catch((err) => {
        const errorId = getUUID();
        const type = QSHEET.FETCH_REJECTED;
        const newError = { errorId, type, error: err?.response?.data };
        actionScripts.ADD_ERROR.run(newError);
        dispatch({ type: QSHEET.FETCH_REJECTED, tabId });
        reject(err);
      });
  });

const createQSheet = (dto, payEstimateTabId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: QSHEET.CREATE });
    axios
      .post(`${BASE_URL}/api/QSheets`, dto)
      .then((response) => {
        dispatch({
          type: QSHEET.CREATE_FULFILLED,
          payEstimateTabId,
          newQSheetId: response.data,
        });
        resolve(response.data);
      })
      .catch((err) => {
        const errorId = getUUID();
        const type = QSHEET.CREATE_REJECTED;
        const newError = { errorId, type, error: err?.response?.data };
        actionScripts.ADD_ERROR.run(newError);
        dispatch({ type: QSHEET.CREATE_REJECTED });
        reject(err);
      });
  });

const deleteQSheet = (qSheetId, tabId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: QSHEET.DELETE, tabId });
    axios
      .delete(`${BASE_URL}/api/QSheets/${qSheetId}`)
      .then(() => {
        dispatch({ type: QSHEET.DELETE_FULFILLED, tabId, qSheetId });
        resolve();
      })
      .catch((err) => {
        const errorId = getUUID();
        const type = QSHEET.DELETE_REJECTED;
        const newError = { errorId, type, error: err?.response?.data };
        actionScripts.ADD_ERROR.run(newError);
        dispatch({ type: QSHEET.DELETE_REJECTED, tabId });
        reject(err);
      });
  });

const calculateQSheet = (qSheetId, tabId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: QSHEET.CALCULATE, tabId });
    axios
      .post(`${BASE_URL}/api/QSheets/${qSheetId}/Calculate`, {})
      .then(() => {
        dispatch({ type: QSHEET.CALCULATE_FULFILLED, tabId });
        resolve();
      })
      .catch((err) => {
        const errorId = getUUID();
        const type = QSHEET.CALCULATE_REJECTED;
        const newError = { errorId, type, error: err?.response?.data };
        actionScripts.ADD_ERROR.run(newError);
        dispatch({ type: QSHEET.CALCULATE_REJECTED, tabId });
        reject(err);
      });
  });

const checkQSheet = (qSheetId, userRoleCodes, tabId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: QSHEET.CHECK, tabId });
    axios
      .post(`${BASE_URL}/api/QSheets/${qSheetId}/Check`, { userRoleCodes })
      .then(() => {
        dispatch({ type: QSHEET.CHECK_FULFILLED, tabId });
        resolve();
      })
      .catch((err) => {
        const errorId = getUUID();
        const type = QSHEET.CHECK_REJECTED;
        const newError = { errorId, type, error: err?.response?.data };
        actionScripts.ADD_ERROR.run(newError);
        dispatch({ type: QSHEET.CHECK_REJECTED, tabId });
        reject(err);
      });
  });

const revertQSheet = (qSheetId, targetStatus, tabId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: QSHEET.REVERT, tabId });
    axios
      .post(`${BASE_URL}/api/QSheets/${qSheetId}/Revert`, { targetStatus })
      .then(() => {
        dispatch({ type: QSHEET.REVERT_FULFILLED, tabId });
        resolve();
      })
      .catch((err) => {
        const errorId = getUUID();
        const type = QSHEET.REVERT_REJECTED;
        const newError = { errorId, type, error: err?.response?.data };
        actionScripts.ADD_ERROR.run(newError);
        dispatch({ type: QSHEET.REVERT_REJECTED, tabId });
        reject(err);
      });
  });

const saveQSheet = (qSheetId, dto, tabId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: QSHEET.SAVE, tabId });
    axios
      .put(`${BASE_URL}/api/QSheets/${qSheetId}/Save`, dto)
      .then(() => {
        dispatch({ type: QSHEET.SAVE_FULFILLED, tabId });
        resolve();
      })
      .catch((err) => {
        const errorId = getUUID();
        const type = QSHEET.SAVE_REJECTED;
        const newError = { errorId, type, error: err?.response?.data };
        actionScripts.ADD_ERROR.run(newError);
        dispatch({ type: QSHEET.SAVE_REJECTED, tabId });
        reject(err);
      });
  });

const refreshQuantities = (qSheetId, tabId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: QSHEET.REFRESH, tabId });
    axios
      .post(`${BASE_URL}/api/QSheets/${qSheetId}/RefreshQuantities`)
      .then(() => {
        dispatch({ type: QSHEET.REFRESH_FULFILLED, tabId });
        resolve();
      })
      .catch((err) => {
        const errorId = getUUID();
        const type = QSHEET.REFRESH_REJECTED;
        const newError = { errorId, type, error: err?.response?.data };
        actionScripts.ADD_ERROR.run(newError);
        dispatch({ type: QSHEET.REFRESH_REJECTED, tabId });
        reject(err);
      });
  });

const uploadAttachment = (qSheetId, file, tabId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: QSHEET.UPLOAD_ATTACHMENT, tabId });
    const formData = new FormData();
    formData.append("file", file);
    axios
      .post(`${BASE_URL}/api/QSheets/${qSheetId}/Attachments`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        dispatch({ type: QSHEET.UPLOAD_ATTACHMENT_FULFILLED, tabId });
        resolve(response.data);
      })
      .catch((err) => {
        const errorId = getUUID();
        const type = QSHEET.UPLOAD_ATTACHMENT_REJECTED;
        const newError = { errorId, type, error: err?.response?.data };
        actionScripts.ADD_ERROR.run(newError);
        dispatch({ type: QSHEET.UPLOAD_ATTACHMENT_REJECTED, tabId });
        reject(err);
      });
  });

const deleteAttachment = (qSheetId, attachmentId, tabId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: QSHEET.DELETE_ATTACHMENT, tabId });
    axios
      .delete(`${BASE_URL}/api/QSheets/${qSheetId}/Attachments/${attachmentId}`)
      .then(() => {
        dispatch({ type: QSHEET.DELETE_ATTACHMENT_FULFILLED, tabId });
        resolve();
      })
      .catch((err) => {
        const errorId = getUUID();
        const type = QSHEET.DELETE_ATTACHMENT_REJECTED;
        const newError = { errorId, type, error: err?.response?.data };
        actionScripts.ADD_ERROR.run(newError);
        dispatch({ type: QSHEET.DELETE_ATTACHMENT_REJECTED, tabId });
        reject(err);
      });
  });

const saveCem6004Reference = (qSheetId, dto, tabId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: QSHEET.RECORD_CEM6004, tabId });
    axios
      .put(`${BASE_URL}/api/QSheets/${qSheetId}/Cem6004Reference`, dto)
      .then(() => {
        dispatch({ type: QSHEET.RECORD_CEM6004_FULFILLED, tabId });
        resolve();
      })
      .catch((err) => {
        const errorId = getUUID();
        const type = QSHEET.RECORD_CEM6004_REJECTED;
        const newError = { errorId, type, error: err?.response?.data };
        actionScripts.ADD_ERROR.run(newError);
        dispatch({ type: QSHEET.RECORD_CEM6004_REJECTED, tabId });
        reject(err);
      });
  });

const qSheetActions = {
  fetchQSheet,
  createQSheet,
  deleteQSheet,
  calculateQSheet,
  checkQSheet,
  revertQSheet,
  saveQSheet,
  refreshQuantities,
  uploadAttachment,
  deleteAttachment,
  saveCem6004Reference,
};

export default qSheetActions;
